<template>
    <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="#" replace to="/">Admin</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
                <b-nav-item to="/users" href="#">Users</b-nav-item>
                <b-nav-item to="/vehicles" href="#">Vehicles</b-nav-item>
                <b-nav-item to="/sessions" href="#">Sessions</b-nav-item>

                <b-nav-item-dropdown>
                    <template v-slot:button-content>Trip</template>
                    <b-dropdown-item to="/trips">Trip List</b-dropdown-item>
                    <b-dropdown-item to="/trip/pricing">Pricing</b-dropdown-item>
                    <b-dropdown-item to="/trip/membershipprice">Membership Price</b-dropdown-item>
                    <b-dropdown-item to="/trip/protectionprice">Protection Price</b-dropdown-item>
                    <b-dropdown-item to="/specialdays">Special Days</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">{{name}} {{surname}}</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>


<script>
  export default {
    name: 'Header',
    data() {
      return {
        name: this.$store.state.profile.name,
        surname: this.$store.state.profile.surname,
      }
    }
  }
</script>
